/**
 * track via google analytics 4
 * For new tracking events, existing event names are to be preferred.
 * see: https://trumpf.sharepoint.com/:x:/r/sites/P-GBLGoogleAnalytics/Freigegebene%20Dokumente/General/GA360/20230303_Account-Structure.xlsx?d=w3f4b005cf5474252a5af51c9f744877a&csf=1&web=1&e=EjPqbU
 **/
/* eslint-disable @typescript-eslint/no-explicit-any */
export function track(
    event_name: string,
    data: any,
    debug: boolean = false,
    event: string = "generic_ga4_event"
) {
    const trackingData = {
        ...data,
        event_name,
        event,
    };
    if (debug) {
        console.log("tracking", trackingData);
    }
    if ((window as any).ITdataLayer) {
        (window as any).ITdataLayer.push(trackingData);
    }
}
